/* Terroir Tastings: køb direkte fra produktkort.
   Virker også efter Dawns filtre har genindlæst listen (event delegation). */
(function () {
  if (window.__ttCardInit) return;
  window.__ttCardInit = true;
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-tt-card-select]');
    if (!sel) return;
    var parts = sel.value.split(':');
    var form = sel.closest('form');
    form.querySelector('input[name="id"]').value = parts[0];
    form.querySelector('input[name="quantity"]').value = parts[1] || 1;
  });

  function refreshCartBubble() {
    fetch(rootUrl + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var el = document.getElementById('cart-icon-bubble');
        if (!el || !s['cart-icon-bubble']) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = s['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section');
        el.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-tt-card-form]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('.tt-card__btn');
    var label = btn.dataset.label || btn.textContent;
    btn.disabled = true;
    fetch(rootUrl + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Fejl');
        refreshCartBubble();
        btn.classList.add('is-done');
        btn.textContent = btn.dataset.added || '✓';
        setTimeout(function () { btn.classList.remove('is-done'); btn.textContent = label; }, 1800);
      })
      .catch(function (err) {
        btn.textContent = err.message.length < 28 ? err.message : 'Fejl';
        setTimeout(function () { btn.textContent = label; }, 2500);
      })
      .then(function () { btn.disabled = false; });
  });
})();